import ReportController from './report.controller';

export default class ReferralReportController extends ReportController
{
	get endpoint() {
		return 'referral';
	}

	get title() {
		return 'Referral Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/referral.report.controller.js
 **/